/**
 * An extensive mathjs library for JavaScript and Node.js
 *  Features
 * Supports numbers, big numbers, complex numbers, fractions, units, strings, arrays, and matrices.
 * Is compatible with JavaScript’s built-in mathjs library.
 * Contains a flexible expression parser.
 * Does symbolic computation.
 * Comes with a large set of built-in functions and constants.
 * Can be used as a command line application as well.
 * Runs on any JavaScript engine.
 * Is easily extensible.
 * Open source.
 */
import * as math from 'mathjs';
// const mathjs = require('mathjs');
export function excuter(expression) {
  try {
    const resutl = math.eval(expression);
    return resutl;
  } catch (err) {
    throw new SyntaxError(err);
  }
}

export function addition(num1, num2) {
  try {
    const resutl = math.format(math.chain(math.bignumber(num1)).add(math.bignumber(num2)).done());
    return resutl;
  } catch (err) {
    throw new SyntaxError(err);
  }
}
export function subtract(num1, num2) {
  try {
    const resutl = math.format(math.chain(math.bignumber(num1)).subtract(math.bignumber(num2)).done());
    return resutl;
  } catch (err) {
    throw new SyntaxError(err);
  }
}
export function multiply(num1, num2) {
  try {
    const resutl = math.format(math.chain(math.bignumber(num1)).multiply(math.bignumber(num2)).done());
    return Number(resutl);
  } catch (err) {
    throw new SyntaxError(err);
  }
}
export function divide(num1, num2) {
  try {
    const resutl = math.format(math.chain(math.bignumber(num1)).divide(math.bignumber(num2)).done());
    return Number(resutl);
  } catch (err) {
    throw new SyntaxError(err);
  }
}



// WEBPACK FOOTER //
// ./src/untils/math.js